function equalizeCardRows(){document.querySelectorAll(".card-list.grid").forEach(function(grid){var columns=Array.from(grid.querySelectorAll(".card-list__column"));if(columns.length){var colCards=columns.map(function(col){return Array.from(col.querySelectorAll(".card__wrapper"))});colCards.forEach(function(cards){cards.forEach(function(c){c.style.minHeight=""})});for(var maxRows=Math.max.apply(null,colCards.map(function(c){return c.length})),row=0;row<maxRows;row++){var rowCards=[];if(colCards.forEach(function(cards){cards[row]&&rowCards.push(cards[row])}),!!rowCards.length){var maxH=Math.max.apply(null,rowCards.map(function(c){return c.offsetHeight}));rowCards.forEach(function(c){c.style.minHeight=maxH+"px"})}}}})}window.addEventListener("load",function(){setTimeout(equalizeCardRows,500),setTimeout(equalizeCardRows,1500)}),window.addEventListener("resize",function(){clearTimeout(window._belEqTimer),window._belEqTimer=setTimeout(equalizeCardRows,300)});

// Promo bar padding fix — apply ONCE then disconnect to prevent infinite loop
(function(){
  function getPromoHeight(){
    var el=document.getElementById("bel-promo-bar");
    if(!el)return 0;
    var style=window.getComputedStyle(el);
    return style.display==="none"||style.visibility==="hidden"?0:el.offsetHeight||0;
  }
  var applied=false;
  var observer=new MutationObserver(function(){
    if(applied)return;
    var pt=parseFloat(document.body.style.paddingTop)||0;
    if(pt>0){
      var promoH=getPromoHeight();
      if(promoH>0){
        applied=true;          // flag BEFORE DOM change
        observer.disconnect(); // stop watching immediately
        document.body.style.paddingTop=(pt+promoH)+"px";
      }
    }
  });
  document.addEventListener("DOMContentLoaded",function(){
    observer.observe(document.body,{attributes:true,attributeFilter:["style"]});
    setTimeout(function(){observer.disconnect();},5000); // safety disconnect after 5s
  });
})();
